// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.162.8-0-g0cdf9e837",
    "hash": "g0cdf9e837",
    "distance": 0,
    "tag": "v1.162.8",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.162.8",
        "major": 1,
        "minor": 162,
        "patch": 8,
        "prerelease": [],
        "build": [],
        "version": "1.162.8"
    },
    "suffix": "0-g0cdf9e837",
    "semverString": "1.162.8",
    "version": "0.0.53",
    "assetVersion": 1792479221002
};
/* tslint:enable */
